const DAY_MS = 24 * 60 * 60 * 1000;

// The picker yields local dates; the API buckets by UTC day. Use the picked
// calendar days as UTC days: [from 00:00Z, day-after-to 00:00Z). Both ends are
// built with Date.UTC from the calendar fields — never by adding days to a
// Date in local time, which a DST change would shift off midnight.
export const toUtcRange = ({ from, to }) => ({
  from: new Date(Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())),
  to: new Date(Date.UTC(to.getFullYear(), to.getMonth(), to.getDate() + 1)),
});

/** Calendar days the picked range covers, inclusive of both ends. */
export const rangeDays = (range) => {
  const { from, to } = toUtcRange(range);
  return Math.round((to - from) / DAY_MS);
};
